<template>
  <div
    class="column-resizer"
    :class="{ active: isActive }"
    @mousedown="onMouseDown"
    @click.stop
  ></div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "ColumnResizer",

  props: {
    fieldKey: {
      type: String,
      required: true,
    },
    isResizing: {
      type: Boolean,
      default: false,
    },
    currentField: {
      type: String,
      default: null,
    },
  },

  emits: ["startResize"],

  setup(props, { emit }) {
    const isActive = computed(
      () => props.isResizing && props.currentField === props.fieldKey,
    );

    const onMouseDown = (event: MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();
      emit("startResize", event);
    };

    return {
      isActive,
      onMouseDown,
    };
  },
});
</script>

<style scoped>
.column-resizer {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  background: transparent;
  z-index: 10;
  transition: background-color 0.15s ease;
}

.column-resizer:hover {
  background: rgba(0, 123, 255, 0.3);
}

.column-resizer.active {
  background: #007bff;
}

.column-resizer::after {
  content: "";
  position: absolute;
  right: -2px;
  top: 0;
  bottom: 0;
  width: 4px;
}
</style>
